// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__4Fn-9","container":"Footer_container__QYkhH","footerInfo":"Footer_footerInfo__sjmJf"};